import { Action } from "features/documents";
import { FolderType, Categorie_pieces, Sections_dossier } from "shared/types/types";
import Card from "./Card";
import DocList from "./DocList";
import FileUploadButton from "../FileUploadButton/FileUploadButton";
import FileUploader from "../FileUploader";
import File from "../File/File";
import EmptyContent from "../EmptyContent";
import React, { useContext } from "react";
import { UserContext } from "features/account";
import { FolderContext } from "features/documents";
import { useParams } from "react-router-dom";

const getDescriptionForCategory = (category: Categorie_pieces): string => {
    switch (category) {
        case Categorie_pieces.IDENTITE:
            return "Le propriétaire ou l'agence immobilière peut demander une pièce d'identité en cours de validité, toute qu'une carte d'identité, un passeport, un permis de conduire ou une carte de séjour/résident/UE-EEE.";
        case Categorie_pieces.DOMICILE:
            return "Le propriétaire peut exiger un justificatif de domicile : 3 quittances de loyer, attestation d'hébergement, élection de domicile ou taxe foncière/titre de propriété.";
        case Categorie_pieces.SITUATION_PRO:
            return "Le propriétaire peut demander un justificatif d'activité : contrat de travail, extrait kbis, immatriculation, certificat Insee, carte professionnelle, preuve d'activité, ou carte/certificat étudiant.";
        case Categorie_pieces.RESSOURCES:
            return "Le propriétaire peut exiger un justificatif de ressources : Avis d'imposition, fiches de paie, bilans ou attestation comptable, allocations/retraites/indemnités, taxe foncière ou titre de propriété, revenus fonciers ou financiers, aides au logement, indemnités de stage ou bourse.";
        default:
            return "";
    }
};

const uid = () => Math.random().toString(36).slice(2, 10);

export default function LocatairePanel({ dossier, dispatch}: {dossier:FolderType;dispatch: React.Dispatch<Action>; }){

    const { user, isVerified } = useContext(UserContext);
    const type = user?.type;
    const { folder, tryRemoveFolder, tryGetFolder, tryChangeVisibility, tryAddFileToFolder, partners } = useContext(FolderContext);

    let { id } = useParams();

    const fileUploaderProps = {
        className: "mb-0",
        title: "Ajouter",
        allowedFormats:
          "application/pdf, image/jpeg, image/png, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        onDelete: () => console.log("delete"),
        isList: false,
    };

    const handleUploadFile = async (files: any, fileType: string) => {
        files.map(async (file: any) => {
            try {
                await tryAddFileToFolder(type, id, file, fileType);
                // Fetch folder when add folder because reactivity doesn't work on the response addFolder
                await tryGetFolder(type, dossier?.id.toString());
            } catch (error) {
                console.log(error);
            }
        });
    };
    return (
        <div style={{flex: 1, padding: '1rem', display: 'flex', flexDirection:'column', gap: '1rem'}}>
            {Object.values(Categorie_pieces).map(category => {
                return (
                    <Card key={category} title={category} right={<span style={{fontSize:12, color: '#64748b'}}>{getDescriptionForCategory(category)}</span>}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
                            {/*<div style={{
                                border: "2px dashed #d1d5db",
                                borderRadius: "8px",
                                padding: "12px",
                                textAlign: "center",
                                cursor: "pointer",
                                background: "#fafbfc",
                                transition: "all 0.2s",
                                minWidth: 180,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <FileUploadButton
                                  iconMode={false}
                                  ai_thread={null}
                                  selectedTool={null}
                                  setSelectedTool={() => {
                                  }}
                                  user_id="null"
                                  onFileSelect={(file) => {
                                      dispatch({
                                          type: 'ADD_LOCATAIRE_DOC' as any,
                                          id: dossier.id as any,
                                          category,
                                          files: [{ id: uid(), name: file.name }],
                                      } as any);
                                  }}
                                />
                            </div>*/}
                            <DocList
                              key={category}
                              categoriePieces={category}
                              sectionsDossier={Sections_dossier.LOCATAIRE}
                            />

                            {/*<div
                              className="d-flex gap-1 mb-2 "
                              style={{ flexWrap: "wrap" }}>
                                {dossier?.ownerId.toString() === user?.id?.toString() && (
                                  <FileUploader
                                    {...fileUploaderProps}
                                    onChange={(files) => {
                                        handleUploadFile(files, "VERBAL");
                                    }}
                                    isList={false}
                                  />
                                )}
                                {dossier?.documents && dossier?.documents?.length > 0 ? (
                                  dossier?.documents.map((file: any, index: any) => (
                                    <File
                                      key={index}
                                      file={file}
                                      isEditable={dossier?.ownerId.toString() === user?.id?.toString()}
                                    />
                                  ))
                                ) : (
                                  <EmptyContent text="Aucun document dans ce dossier" />
                                )}
                            </div>*/}
                        </div>
                    </Card>
                );
            })}
        </div>
    );
}